export enum ProgramClassesPaperAssessmentsFilterNamesEnum {
  SEARCH = 'search',
}
